@import "../../../_variables.scss";

.Header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
  border-bottom: 1px solid $Border;
  padding-bottom: 16px;
  @media screen and (max-width: $TB) {
    border: 0;
    padding-bottom: 0;
  }

  &__TitleContainer {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  &__Title {
    font-weight: 700;
    font-size: 20px;

    @media (max-width: 768px) {
      font-size: 18px;
    }
    @media screen and (max-width: $TB) {
      font-size: 20px;
    }
  }

  &__Description {
    font-size: 14px;
    color: $TextLabel;
  }

  &__Actions {
    display: flex;
    justify-content: center;
    gap: 8px;
  }
}

.subHeader {
  @media screen and (max-width: $TB) {
    margin-bottom: 16px;
  }
}

.subHeaderTitle {
  @media screen and (max-width: $TB) {
    font-size: 16px;
  }
}
